import { serviceAreas } from '../../mocks/services';

export default function ServiceAreasWidget() {
  return (
    <section className="py-12 sm:py-20 bg-[#f5f5f5]">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-5xl font-black text-[#1a1a1a] text-center mb-8 sm:mb-12">
          SERVING FRESNO &<br />SURROUNDING AREAS
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
          <div className="relative h-64 sm:h-96 rounded-xl overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d206253.4068534778!2d-119.95326844999999!3d36.7468422!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80945de1549e4e9d%3A0x7b12406449a3b811!2sFresno%2C%20CA!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Fresno Service Area Map"
            ></iframe>
          </div>

          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#1a1a1a] mb-4 sm:mb-6">Service Coverage Areas</h3>
            <div className="grid grid-cols-2 gap-3 sm:gap-4">
              {serviceAreas.map((area, index) => (
                <div key={index} className="flex items-center gap-2 sm:gap-3">
                  <i className="ri-map-pin-fill text-[#FFD700] text-lg sm:text-xl"></i>
                  <span className="text-gray-700 font-medium text-sm sm:text-base">{area}</span>
                </div>
              ))}
            </div>
            
            <div className="mt-6 sm:mt-8 p-4 sm:p-6 bg-white rounded-lg shadow-md">
              <p className="text-gray-600 text-sm sm:text-base mb-4">
                We proudly serve Fresno and the surrounding Central Valley with professional electrical services. Our licensed electricians are ready to help with residential, commercial, and emergency electrical needs.
              </p>
              <a href="#get-quote" className="text-[#FFD700] font-bold hover:underline cursor-pointer text-sm sm:text-base">
                Get a Free Quote →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}